import { createContext } from 'react'

const JoyrideContext = createContext()

export default JoyrideContext
